import { Box, Paper, Tab, Tabs } from "@mui/material";
import TrendsFilter from "../TrendsFilter/TrendsFilter";
import { useSelector } from "react-redux";
import TrendsSkeleton from "../helpers/components/TrendsSkeleton";
import { useTrendsLogic } from "../helpers/hooks/useGetTrendsAPI";
import "./TrendsTabs.css";
import React, { lazy, Suspense, useEffect } from "react";
import { selectUserData } from "../../../../../features/userSlice";
const CustomerAcquisitionCostTabs = lazy(
  () => import("./CustomerAcquisitionCostTabs")
);
const ClickAndImpressionTabs = lazy(() => import("./ClickAndImpressionTabs"));
const CostPerAcquisitionTabs = lazy(() => import("./CostPerAcquisitionTabs"));
const ConverstionRateTabs = lazy(() => import("./ConverstionRateTabs"));
const FirstTimeDepositTabs = lazy(() => import("./FirstTimeDepositTabs"));
const PlayerValueTabs = lazy(() => import("./PlayerValueTabs"));
const ProfitTabs = lazy(() => import("./ProfitTabs"));
const RevenueShareTabs = lazy(() => import("./RevenueShareTabs"));

type TrendsTabsProps = {
  value: number;
  onChange: (event: React.SyntheticEvent, newValue: number) => void;
};
function CustomTabPanel(props: any) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}
function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const TrendsTabs: React.FC<TrendsTabsProps> = ({ value, onChange }) => {
  const {
    dataSet,
    isLoadingFilter,
    selectedSharedUid,
    // activityNotesDataGlobal,
    fetchBy,
    loadingTrafficSourceFilters,
  } = useSelector((state: any) => state.trends);
  const { fetchActivityNotes } = useTrendsLogic();
  const userDataForWebsite = useSelector(selectUserData);

  const extractSiteIdsByDimensions = (
    userDataForWebsite: any,
    selectedSharedUid: string[]
  ) => {
    const siteIds: string[] = [];

    if (
      !userDataForWebsite?.data?.website_permissions ||
      !Array.isArray(selectedSharedUid)
    ) {
      return siteIds;
    }

    // Iterate through each website permission
    userDataForWebsite.data.website_permissions.forEach((permission: any) => {
      const siteId = Object.keys(permission)[0]; // Extract the key like "bfdccffb44ac41d999a86cc4b32dc243"
      const siteDetails = permission[siteId];

      if (siteDetails?.dimensions?.length > 0) {
        // Check if any dimension_name matches with selectedSharedUid
        const hasMatchingDimension = siteDetails.dimensions.some((dim: any) =>
          selectedSharedUid.includes(dim.dimension_name)
        );

        if (hasMatchingDimension) {
          siteIds.push(siteId);
        }
      }
    });

    return siteIds;
  };

  const resultByDimensions = extractSiteIdsByDimensions(
    userDataForWebsite,
    selectedSharedUid
  );

  useEffect(() => {
    const sharedUids = Array.isArray(selectedSharedUid)
      ? selectedSharedUid
      : selectedSharedUid
      ? [selectedSharedUid]
      : [];
    const dimensionUids = Array.isArray(resultByDimensions)
      ? resultByDimensions
      : resultByDimensions
      ? [resultByDimensions]
      : [];
    if (fetchBy === "site" && sharedUids.length > 0) {
      fetchActivityNotes(sharedUids);
    } else if (fetchBy === "dimension" && dimensionUids.length > 0) {
      fetchActivityNotes(dimensionUids);
    }
    // eslint-disable-next-line
  }, [fetchActivityNotes]);

  return (
    <Paper sx={{ marginTop: 2 }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={onChange}
          indicatorColor="secondary"
          aria-label="trends tabs"
          sx={{
            "& .MuiTab-root": {
              color: "#00000099",
              "&.Mui-selected": {
                color: "#9C27B0",
              },
            },
            "& .MuiTabs-flexContainer": {
              justifyContent: "flex-start",
            },
          }}
        >
          <Tab label="CAC" {...a11yProps(0)} />
          <Tab label="CLICKS & IMPRESSIONS" {...a11yProps(1)} />
          <Tab label="CPA" {...a11yProps(2)} />
          <Tab label="CVR" {...a11yProps(3)} />
          <Tab label="FTD" {...a11yProps(4)} />
          <Tab label="PV" {...a11yProps(5)} />
          <Tab label="PROFIT" {...a11yProps(6)} />
          <Tab label="RS" {...a11yProps(7)} />
        </Tabs>
      </Box>
      {dataSet === "click" ? <TrendsFilter /> : null}
      {!isLoadingFilter && !loadingTrafficSourceFilters ? (
        <>
          <CustomTabPanel value={value} index={0}>
            <Suspense
              fallback={[...Array(2)].map((_, index) => (
                <TrendsSkeleton key={index} />
              ))}
            >
              <CustomerAcquisitionCostTabs />
            </Suspense>
          </CustomTabPanel>
          <CustomTabPanel value={value} index={1}>
            <Suspense
              fallback={[...Array(2)].map((_, index) => (
                <TrendsSkeleton key={index} />
              ))}
            >
              <ClickAndImpressionTabs />
            </Suspense>
          </CustomTabPanel>
          <CustomTabPanel value={value} index={2}>
            <Suspense
              fallback={[...Array(2)].map((_, index) => (
                <TrendsSkeleton key={index} />
              ))}
            >
              <CostPerAcquisitionTabs />
            </Suspense>
          </CustomTabPanel>
          <CustomTabPanel value={value} index={3}>
            <Suspense
              fallback={[...Array(2)].map((_, index) => (
                <TrendsSkeleton key={index} />
              ))}
            >
              <ConverstionRateTabs />
            </Suspense>
          </CustomTabPanel>
          <CustomTabPanel value={value} index={4}>
            <Suspense
              fallback={[...Array(2)].map((_, index) => (
                <TrendsSkeleton key={index} />
              ))}
            >
              <FirstTimeDepositTabs />
            </Suspense>
          </CustomTabPanel>
          <CustomTabPanel value={value} index={5}>
            <Suspense
              fallback={[...Array(2)].map((_, index) => (
                <TrendsSkeleton key={index} />
              ))}
            >
              <PlayerValueTabs />
            </Suspense>
          </CustomTabPanel>
          <CustomTabPanel value={value} index={6}>
            <Suspense
              fallback={[...Array(2)].map((_, index) => (
                <TrendsSkeleton key={index} />
              ))}
            >
              <ProfitTabs />
            </Suspense>
          </CustomTabPanel>
          <CustomTabPanel value={value} index={7}>
            <Suspense
              fallback={[...Array(2)].map((_, index) => (
                <TrendsSkeleton key={index} />
              ))}
            >
              <RevenueShareTabs />
            </Suspense>
          </CustomTabPanel>
        </>
      ) : (
        [...Array(2)].map((_, index) => <TrendsSkeleton key={index} />)
      )}
    </Paper>
  );
};

export default TrendsTabs;
